import { InMemoryWebStorage, WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';

import type { OIDCConfig } from './config';

// A non-secret hint that the user signed in during this tab session, so a
// reload can bounce through Keycloak (instant with its session cookie)
// instead of showing "Sign in" again. Tokens themselves are never stored.
export const SIGNED_IN_HINT = 'illumilink.signedIn';
export const TENANT_KEY = 'illumilink.tenant';

export function readHint(key: string): string | null {
  try {
    return sessionStorage.getItem(key) ?? localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeHint(storage: 'session' | 'local', key: string, value: string | null) {
  try {
    const s = storage === 'session' ? sessionStorage : localStorage;
    if (value === null) s.removeItem(key);
    else s.setItem(key, value);
  } catch {
    /* storage unavailable (private mode, thumbnails): hints are optional */
  }
}

/**
 * Authorization Code + PKCE against Keycloak. Tokens live in memory only
 * (RAX-010: never in web storage), and renew with the refresh token.
 */
export function oidcSettings(
  oidc: OIDCConfig,
  origin = window.location.origin,
): UserManagerSettings {
  return {
    authority: oidc.authority,
    client_id: oidc.clientId,
    redirect_uri: `${origin}/`,
    post_logout_redirect_uri: `${origin}/`,
    response_type: 'code',
    scope: 'openid profile email organization',
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),
  };
}
